import { Container } from "./styles";
import githubIcon from "../../assets/github.svg";
import externalLink from "../../assets/external-link.svg";
import ScrollAnimation from "react-animate-on-scroll";

const projects = [
  {
    title: "Hirexer - Resource Argumentation Platform (Frontend)",
    description: "React-based frontend for a resource management platform where companies can register workspaces, share resources, connect team members via in-app meetings, manage applications and posts, with role-based access control.",
    technologies: ["React", "JavaScript", "CSS", "Tailwind CSS"],
    githubLink: "https://github.com/Pushprajmajhi65/Hirexer_frontend_",
    externalLink: null,
    icon: "folder"
  },
  
  {
    title: "Dronemandu - Drone E-commerce Platform",
    description: "Developed a JSP/Servlet-based e-commerce platform specializing in drone sales, focusing on core development concepts and learning. Implemented product listings, shopping cart functionality, and order processing systems.",
    technologies: ["Java", "JSP", "Servlet", "MySQL"],
    githubLink: "https://github.com/Pushprajmajhi65/Dronemandu",
    externalLink: null,
    icon: "folder"
  },
  
  
  {
    title: "Hirexer - Resource Argumentation Platform (Backend)",
    description: "Django-based backend API for a resource management platform enabling workspace registration, resource sharing, role-based access control, application and post management, and real-time communication using Twilio RTC integration.",
    technologies: ["Django", "Python", "Django REST Framework", "Twilio RTC"],
    githubLink: "https://github.com/Pushprajmajhi65/hirexer_backend",
    externalLink: null,
    icon: "folder"
  },
  {
    title: "Sajha Pustak - Online Bookstore (Frontend)",
    description: "React-based frontend for an online bookstore platform where vendors can list books and customers can browse, add to wishlist or cart, and place orders. Built using modern UI and state management tools.",
    technologies: ["React", "Tailwind CSS", "TanStack Query", "PostgreSQL", "Neno Database"],
    githubLink: "https://github.com/nimeshmeh7a/SajhaPustak",
    externalLink: null,
    icon: "folder"
  },
  {
    title: "Sajha Pustak - Online Bookstore (Backend)",
    description: "ASP.NET MVC backend for an online bookstore platform where vendors can manage book listings and customers can browse, add to cart or wishlist, and place orders. Implements MVC architecture for organized and scalable development.",
    technologies: ["ASP.NET", "MVC", "C#", "SQL Server"],
    githubLink: "https://github.com/nimeshmeh7a/web_AD",
    externalLink: null,
    icon: "folder"
  },
  {
    title: "Trackify - Personal Expense Tracker",
    description: "A desktop application for tracking personal expenses, allowing users to manage transactions, set budgets, and monitor credit/debit statistics. Built using MudBlazor UI components in a .NET environment.",
    technologies: [".NET", "C#", "MudBlazor", "Desktop App"],
    githubLink: "https://github.com/Pushprajmajhi65/Trackify",
    externalLink: null,
    icon: "code"
  },
  {
    title: "Meeting App - Core WebRTC Implementation",
    description: "A simple meeting application built using core WebRTC APIs in Node.js with basic HTML frontend. Developed as a hands-on project to understand the fundamentals of WebRTC peer-to-peer communication.",
    technologies:["WebRTC", "Node.js", "HTML", "JavaScript"],
    githubLink: "https://github.com/Pushprajmajhi65/meeting_app",
    externalLink: null,
    icon: "folder"
  },
   {
    title:  "Recipe App - Django CRUD",
    description: "A basic recipe management application built with Django showcasing fundamental CRUD operations. Users can add, edit, view, and delete recipes through a simple and clean interface.",
    technologies:["Django", "Python", "HTML", "CSS"],
    githubLink:"https://github.com/Pushprajmajhi65/recipe_app_-django",
    externalLink: null,
    icon: "folder"
  }
  ,
   {
    title:  "Student Management System - Java Swing",
    description:"A desktop-based student management application developed using Java Swing. Allows users to register students, manage enrollment details, course duration, tuition fees, and other core information through an interactive GUI.",
    technologies:["Java", "Swing", "OOP"],
    githubLink:"https://github.com/Pushprajmajhi65/Student-management-system",
    externalLink: null,
    icon: "folder"
  }

  
];

const FolderIcon = () => (
  <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
    <title>Folder</title>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
  </svg>
);

const CodeIcon = () => (
  <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
    <title>Code</title>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
  </svg>
);

export function Project() {
  return (
    <Container id="project">
      <h2>My Projects of 2024- 2025</h2>
      <div className="projects">
        {projects.map((project, index) => (
          <ScrollAnimation key={index} animateIn="flipInX">
            <div className="project">
              <header>
                {project.icon === "folder" ? <FolderIcon /> : <CodeIcon />}
                <div className="project-links">
                  <a href={project.githubLink} target="_blank" rel="noreferrer">
                    <img src={githubIcon} alt="GitHub" />
                  </a>
                  {project.externalLink && (
                    <a href={project.externalLink} target="_blank" rel="noreferrer">
                      <img src={externalLink} alt="Visit site" />
                    </a>
                  )}
                </div>
              </header>
              <div className="body">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
              <footer>
                <ul className="tech-list">
                  {project.technologies.map((tech, techIndex) => (
                    <li key={techIndex}>{tech}</li>
                  ))}
                </ul>
              </footer>
            </div>
          </ScrollAnimation>
        ))}
      </div>
    </Container>
  );
}